import GamesList from "../../lists/games/GamesList";
import GamesInComingMessage from "./GamesInComingMessage";
import SystemScreenHeader from "../../headers/SystemScreenHeader";

export default function GamesScreenContent() {
    // Used in GamesScreen to display header, games list
    // and on coming warning message

    // BUILD
    return (
        <div className="w-full flex flex-col justify-start items-start">
            <SystemScreenHeader title={"Jeux éducatifs"}
                                subtitle={"Tu maitrises ton cours mais tu fais encore des erreurs ?\nDéveloppe des réflexes quasi instinctifs sur les basiques en mathématiques."} />
            <GamesList />
            <GamesInComingMessage />
        </div>
    );

}